import { jsx } from "react/jsx-runtime";
import { Button } from "@zillow/constellation-10";
import { useFormState } from "react-hook-form";
const ApexSubmit = ({
  children,
  ...rest
}) => {
  const {
    isSubmitting
  } = useFormState();
  return /* @__PURE__ */ jsx(Button, { type: "submit", ...rest, disabled: isSubmitting, loading: isSubmitting, children });
};
export {
  ApexSubmit as default
};
